export default __webpack_public_path__ + "static/media/EttinaBhuja.b8ee82de.jpg";